import { render, staticRenderFns } from "./SdpApp.vue?vue&type=template&id=1f7f7f16&scoped=true&"
import script from "./SdpApp.vue?vue&type=script&lang=ts&"
export * from "./SdpApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f7f7f16",
  null
  
)

export default component.exports